export default {
  methods: {
    extractAddress(address) {
      let pattern = {
        street: address?.street_number,
        name: address?.name,
        // adm_1: address?.adm_1,
        // adm_2: address?.adm_2,
        locality: address?.locality,
        country: address?.country,
      };
      Object.keys(pattern).forEach(function(key) {
        if (pattern[key] === "" || pattern[key] === undefined) {
          delete pattern[key];
        }
      });
      let values = Object.values(pattern);
      let joinedValues = values.map((item) => {
        return ` ${item}`
      });

      return joinedValues.join();
    },
  },
};
